export default __webpack_public_path__ + "static/media/structure_dark.f981ee9d.svg";